"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequestStatus = void 0;
const status_1 = require("../../../status");
const createRequestStatus = (type) => ({
    standby: () => new status_1.RequestStatus(type, status_1.RequestStatusValue.STANDBY),
    fetching: () => new status_1.RequestStatus(type, status_1.RequestStatusValue.BUSY),
    success: () => new status_1.RequestStatus(type, status_1.RequestStatusValue.SUCCESS),
    failed: () => new status_1.RequestStatus(type, status_1.RequestStatusValue.FAILURE)
});
exports.createRequestStatus = createRequestStatus;
//# sourceMappingURL=index.js.map